import type {RootState} from '../store';
import {getSelectedGroupId} from '../team/teamSelectors';
import {createSelector} from '../util';

export const getCustomerFeatureFlags = (state: RootState) =>
  state.featureFlags.get('customerFlags');

export const getGroupFeatureFlags = (state: RootState) => {
  const groupId = getSelectedGroupId(state);
  const groupFlags = state.featureFlags.getIn(['groupFlags', groupId]);
  return groupFlags;
};

const getUserFeatureFlags = (state: RootState) =>
  state.featureFlags.get('userFlags');

export const selectCombinedFeatureFlags = createSelector(
  [getCustomerFeatureFlags, getGroupFeatureFlags, getUserFeatureFlags],
  (customerFlags, groupFlags, userFlags) => ({
    ...customerFlags,
    ...groupFlags,
    ...userFlags,
  })
);
